<hr />

<div>
  <!--*ngIf="this.payments.DisplayMessage"-->
  <p class="h5 text-left py-2 text-muted" data-testid="cs-payment-type-title">
      <strong>
          {{
        this.selectedPaymentType == PaymentTypeEnum.CreditCard
          ? "Pay By Credit Card"
          : this.selectedPaymentType == PaymentTypeEnum.Lease
          ? "Apply for Lease"
          : this.selectedPaymentType == PaymentTypeEnum.PayPal
          ? "Pay with PayPal"
          : this.selectedPaymentType == PaymentTypeEnum.Klarna
          ? "Pay with Klarna"
          : this.selectedPaymentType == PaymentTypeEnum.SavedCreditCard
          ? "Pay By Credit Card"
          : ""
          }}
      </strong>
  </p>

  <div *ngIf="this.selectedPaymentType === PaymentTypeEnum.CreditCard || this.selectedPaymentType === PaymentTypeEnum.SavedCreditCard" data-test="payment-type-container">
    <div>
      <!-- No saved cards area -->
      <ng-container *ngIf="this.selectedPaymentType === PaymentTypeEnum.CreditCard" data-test="credit-card-form">

          <ng-container *ngIf="showAmexNotAllowedErrorMessage">
              <div class="alert alert-danger" data-testid="amex-payment-blocked">
                  <p class="font-small">
                      We do not accept <strong>American Express</strong>. Please use a different card or method of payment to proceed.
                      <a href="https://www.vistek.ca/about/helpcentre/#wayspayorder" target="_blank" class="info-link">Learn more</a>.
                  </p>
              </div>
          </ng-container>
          
        <app-credit-card-form (validCardDetected)="onValidCardDetected($event)" data-testid="credit-card-entry-component" #creditCardFormComponent></app-credit-card-form>

        <ng-container *ngIf="isLoggedIn">
          <ng-container *ngIf="savedPaymentMethodFeatureFlag">
            <div class="form-check" data-test="save-payment-method-checkbox">
              <input type="checkbox" class="form-check-input" [formControl]="saveTokenFormControl" id="savePaymentDetailsForLater" name="savePaymentDetailsForLater" />
              <label class="form-check-label" for="savePaymentDetailsForLater">
                <span class="font-small">Save my payment details for later.</span>
              </label>
              <br />
              <span class="save-payment-method-blur">To make your checkout faster next time, and to easily pay from different devices, save your card info.</span>
            </div>
            <div class="form-check" data-test="set-default-payment-method-checkbox" *ngIf="isSavingPaymentMethod">
              <input type="checkbox" class="form-check-input" id="setDefaultPaymentMethod" name="setDefaultPaymentMethod" />
              <label class="form-check-label" for="setDefaultPaymentMethod">
                <span class="font-small">Set as default?</span>
              </label>
              <br />
              <span class="save-payment-method-blur">If you have multiple saved cards, check this to set this card as default.</span>
            </div>
            <hr />
          </ng-container>
        </ng-container>
      </ng-container>
  
      <ng-container *ngIf="this.selectedPaymentType === PaymentTypeEnum.SavedCreditCard" data-test="saved-credit-card-form">
        <form [formGroup]="tokenSelectionForm">
          <div class="row" *ngFor="let token of payments.NetworkTokens; index as i">
            <div class="col pl-0">
              <div class="form-check">
                <input
                  mdbInput
                  class="form-check-input"
                  type="radio"
                  formControlName="tokenSelectionControl"
                  [id]="'token' + i"
                  (change)="onTokenSelected(token)"
                  [value]="token.TokenInstrumentIdentifierId"
                />
                <label class="form-check-label" [for]="'token' + i">
                  <span>{{ token.CardTypeFullName }} XXXX</span>&nbsp;{{ token.CardLast4Digits }}&nbsp;
                  <small class="ml-4">
                    &nbsp;Exp&nbsp;
                    <em>{{ token.CardExpirationMonth }}</em>/<em>{{ token.CardExpirationYear }}</em>
                  </small>
                </label>
              </div>
            </div>
          </div>
        </form>
      </ng-container>
    </div>
  </div>

  <div class="col-lg-12 col-xs-12" *ngIf="this.selectedPaymentType === PaymentTypeEnum.Lease">
    <div>
      <p>
        <img src="/content/images/cart/equilease.png" width="82" style="width: 82px" />
        Select this to apply for new a lease contract with <a href="/about/leasing" target="_blank">Equilease</a>.
      </p>
    </div>
  </div>
  <div class="col-lg-12 col-xs-12" *ngIf="this.selectedPaymentType === PaymentTypeEnum.Quote">
    <div>
      <div class="card">TODO: Quote Form will be here</div>
    </div>
  </div>
  <div class="col-lg-12 col-xs-12">
    <div *ngIf="!this.isPaypalPaymentDone && this.selectedPaymentType === PaymentTypeEnum.PayPal" data-test="paypal-instructions">
      <p>
        When you click the Check Out With PayPal button, we'll route you to PayPal.com to finalize your payment. You
        will be returned to this page to complete your checkout.
      </p>
    </div>
  
    <div
      [ngClass]="selectedPaymentType === PaymentTypeEnum.PayPal && !isPaypalPaymentDone ? 'showpaypal' : 'hidepaypal'"
      data-test="paypal-cart-container"
    >
      <div id="paypal-cart" data-testid="paypal-btn-container"></div>
    </div>
    <div *ngIf="this.isPaypalPaymentDone && this.selectedPaymentType === PaymentTypeEnum.PayPal" data-testid="paypal-authenticated">
      <span>
        <span class="paypal"></span> has authenticated
        <div style="font-weight: bold" class="text-primary p-2" data-test="paypal-email">{{ payments.PaypalPayment?.PaypalEmail }}</div>
        You can complete your purchase now.
      </span>
    </div>
  </div>
  <div class="col-lg-12 col-xs-12" *ngIf="this.selectedPaymentType === PaymentTypeEnum.Klarna" data-test="klarna-container">
    <div class="row mb-2" *ngIf="selectedKlarnaPaymentMethodCategory" data-test="klarna-method-category">
      <div class="col" style="margin: auto">
        {{ selectedKlarnaPaymentMethodCategory.name }}
      </div>
      <div class="col col-auto">
        <img class="klarna" src="{{ selectedKlarnaPaymentMethodCategory.asset_urls.descriptive }}" alt="Klarna" data-test="klarna-method-image" />
      </div>
    </div>
    <div id="klarna-payments-container" [ngClass]="{ hide: !klarnaState.isAvailable }" data-test="klarna-payments-container"></div>
    <div *ngIf="klarnaState.error" data-test="klarna-error">{{ klarnaState.error }}</div>
  </div>
    
    <ng-container *ngIf="selectedPaymentType !== PaymentTypeEnum.GiftCard; else paymentCoveredByGiftCard">
        <p class="h5 text-left py-3 text-muted" data-test="alternate-payment-method-heading">
            <strong>Select Alternate Payment Method</strong>
        </p>

        <ul class="list-group list-group-light list-group-small alt-payment-options">
            <ng-container *ngFor="let paymentType of paymentTypes">
                <ng-container *ngIf="paymentType !== this.selectedPaymentType">
                    <li class="list-group-item border-0 list-group-item-action d-flex align-items-center" [ngSwitch]="paymentType" data-test="payment-type-option">

                        <!-- Klarna -->
                        <ng-container *ngSwitchCase="PaymentTypeEnum.Klarna">
                            <ng-container *ngIf="klarnaState.isAvailable">
                                <a *ngFor="let cat of this.model.Payments.KlarnaPayment.Session.payment_method_categories"
                                   (click)="onPaymentTypeChange(paymentType, cat)"
                                   class="payment-option"
                                   data-testid="payment-type-klarna-link">
                                    <i class="fa-2x padd-left"><img style="width: 70px;" src="{{ cat.asset_urls.descriptive }}" alt="{{ cat.name }}"/></i>
                                    <span>{{ cat.name }}</span>
                                </a>
                            </ng-container>
                        </ng-container>
                        
                        <!-- PayPal -->
                        <ng-container *ngSwitchCase="PaymentTypeEnum.PayPal">
                            <a (click)="onPaymentTypeChange(paymentType)" class="payment-option" data-testid="payment-type-paypal-link">
                                <i class="fa-2x padd-left"><img style="width: 70px;" src="/content/images/cart/paypal.png" alt="PayPal"/></i> PayPal
                            </a>
                        </ng-container>

                        <!-- Credit Card (Generic Icon) -->
                        <ng-container *ngSwitchCase="PaymentTypeEnum.CreditCard">
                            <a (click)="onPaymentTypeChange(paymentType)" class="payment-option" data-test="payment-type-credit-card-link"> 
                                <i class="fas fa-credit-card"></i>Credit Card
                            </a>
                        </ng-container>

                        <!-- Saved Credit Card (Generic Icon) -->
                        <ng-container *ngSwitchCase="PaymentTypeEnum.SavedCreditCard">
                            <a (click)="onPaymentTypeChange(paymentType)" class="payment-option" data-test="payment-type-saved-credit-card-link">
                                <i class="fas fa-credit-card"></i> Saved Credit Card
                            </a>
                        </ng-container>

                        <!-- Default (Other Payment Methods) -->
                        <ng-container *ngSwitchDefault>
                            <a (click)="onPaymentTypeChange(paymentType)" class="payment-option" data-testid="payment-type-default-link">
                                <i class="fas fa-money-check-alt"></i> {{ paymentType }}
                            </a>
                        </ng-container>

                    </li>
                </ng-container>
            </ng-container>
        </ul>

        <div class="alert alert-secondary" role="alert" *ngIf="paymentTypes.length < 2" data-test="no-alternate-payment-alert">
            No alternative payment types are available
        </div>
    </ng-container>
  <ng-template #paymentCoveredByGiftCard>
    <div class="align-items-center mb-1" data-testid="gift-card-covers-entire-order-message">
      <p>Good News! Your gift card covers your entire order total.</p>
      <p>You do not need to add any other payment method.</p>
    </div>
  </ng-template>

  <hr class="divider" *ngIf="!!this.model?.CartSummary?.RequireTerms" />
  <div
  class="col-lg-12 col-xs-12"
  style="padding-top: 20px; padding-bottom: 20px"
  *ngIf="!!this.model?.CartSummary?.RequireTerms"
  data-testid="special-order-terms"
>
  <!-- Material unchecked -->
  <div class="form-check" data-test="form-check">
    <input
      type="checkbox"
      class="form-check-input"
      id="acceptSpecialOrderTerms"
      data-testid="accept-terms-checkbox"
    />
    <label
      class="form-check-label"
      for="acceptSpecialOrderTerms"
    >
      <span style="font-weight: bold">I accept the Special Order terms</span>
    </label>
    <div>
      <br />
      <small>
        Terms: Special orders generally take weeks to be fulfilled by the manufacturer and require a full,
        non-refundable payment. A Special Order product is "final sale". Once we have an ETA we will notify you and
        the date provided will become part of this agreement. ETA dates may change due to manufacturer challenges and
        we will keep you updated as information is available. Special Orders are bound to the terms of our company
        return policy.
      </small>
    </div>
  </div>
</div>

    <hr class="divider" *ngIf="this.model?.CartSummary?.RequireDropshipTerms" />
    <div
        class="col-lg-12 col-xs-12"
        style="padding-top: 20px; padding-bottom: 20px"
        *ngIf="this.model?.CartSummary?.RequireDropshipTerms"
        data-testid="dropship-terms"
    >
        <!-- Material unchecked -->
        <div class="form-check" data-test="form-check">
            <input
                type="checkbox"
                class="form-check-input"
                id="acceptDropshipTerms"
                data-testid="accept-dropship-terms-checkbox"
            />
            <label
                class="form-check-label"
                for="acceptDropshipTerms"
            >
                <span style="font-weight: bold">I accept the dropshipping terms</span>
            </label>
            <div>
                <br />
                <small>
                    Terms: Your order contains a mix of items that are shipped from our warehouse and items that are
                    shipped directly from the manufacturer.
                    You acknowledge that the instant shipping quote provided to you, and paid by you now, is only
                    for the items shipped from our warehouse. 
                    If you paid for package protection, this also applies only to the items shipped from our warehouse. 
                    Any ETA given to you now is only for items shipped from our warehouse.
                    You acknowledge and accept that an additional fee is required for the shipping of the dropshipped items
                    and the fee paid today is not indicative of the final shipping/insurance fee.
                </small>
            </div>
        </div>
    </div>
    
</div>
